import { createContext } from 'react';

import { DEFAULT_DATASET_TYPE } from '../constants.js';
import type { HoneycombDatasetType } from '../types/honeycomb.js';

export const HoneycombDatasetTypeContext =
  createContext<HoneycombDatasetType>(DEFAULT_DATASET_TYPE);
